import { Translation } from '../types';
import { FirstChronicles } from './1chronicles';
import { FirstCorinthians } from './1corinthians';
import { FirstJohn } from './1john';
import { FirstKings } from './1kings';
import { FirstPeter } from './1peter';
import { FirstSamuel } from './1samuel';
import { FirstThessalonians } from './1thessalonians';
import { FirstTimothy } from './1timothy';
import { SecondChronicles } from './2chronicles';
import { SecondCorinthians } from './2corinthians';
import { SecondJohn } from './2john';
import { SecondKings } from './2kings';
import { SecondPeter } from './2peter';
import { SecondSamuel } from './2Samuel';
import { SecondThessalonians } from './2Thessalonians';
import { SecondTimothy } from './2Timothy';
import { ThirdJohn } from './3John';
import { Acts } from './Acts';
import { Amos } from './Amos';
import { Colossians } from './Colossians';
import { Daniel } from './Daniel';
import { Deuteronomy } from './Deuteronomy';
import { Ecclesiastes } from './Ecclesiastes';
import { Ephesians } from './Ephesians';
import { Esther } from './Esther';
import { Exodus } from './Exodus';
import { Ezekiel } from './Ezekiel';
import { Ezra } from './Ezra';
import { Galatians } from './Galatians';
import { Genesis } from './Genesis';
import { Habakkuk } from './Habakkuk';
import { Haggai } from './Haggai';
import { Hebrews } from './Hebrews';
import { Hosea } from './Hosea';
import { Isaiah } from './Isaiah';
import { James } from './James';
import { Jeremiah } from './Jeremiah';
import { Job } from './Job';
import { Joel } from './Joel';
import { John } from "./John";
import { Jonah } from './Jonah';
import { Joshua } from './Joshua';
import { Jude } from './Jude';
import { Judges } from './Judges';
import { Lamentations } from './Lamentations';
import { Leviticus } from './Leviticus';
import { Luke } from './Luke';
import { Malachi } from './Malachi';
import { Mark } from './Mark';
import { Matthew } from './Matthew';
import { Micah } from './Micah';
import { Nahum } from './Nahum';
import { Nehemiah } from './Nehemiah';
import { Numbers } from './Numbers';
import { Obadiah } from './Obadiah';
import { Philemon } from './Philemon';
import { Philippians } from './Philippians';
import { Proverbs } from './Proverbs';
import { Psalms } from './Psalms';
import { Revelation } from './Revelation';
import { Romans } from './Romans';
import { Ruth } from './Ruth';
import { Songs } from './SongOfSolomon';
import { Titus } from './Titus';
import { Zechariah } from './Zechariah';
import { Zephaniah } from './Zephaniah';

export const KJV : Translation = {
  "1 Chronicles": FirstChronicles,
  "1 Corinthians": FirstCorinthians,
  "1 John": FirstJohn,
  "1 Kings": FirstKings,
  "1 Peter": FirstPeter,
  "1 Samuel": FirstSamuel,
  "1 Thessalonians": FirstThessalonians,
  "1 Timothy": FirstTimothy,
  "2 Chronicles": SecondChronicles,
  "2 Corinthians": SecondCorinthians,
  "2 John": SecondJohn,
  "2 Kings": SecondKings,
  "2 Peter": SecondPeter,
  "2 Samuel": SecondSamuel,
  "2 Thessalonians": SecondThessalonians,
  "2 Timothy": SecondTimothy,
  "3 John": ThirdJohn,
  "Acts": Acts,
  "Amos": Amos,
  "Colossians": Colossians,
  "Daniel": Daniel,
  "Deuteronomy": Deuteronomy,
  "Ecclesiastes": Ecclesiastes,
  "Ephesians": Ephesians,
  "Esther": Esther,
  "Exodus": Exodus,
  "Ezekiel": Ezekiel,
  "Ezra": Ezra,
  "Galatians": Galatians,
  "Genesis": Genesis,
  "Habakkuk": Habakkuk,
  "Haggai": Haggai,
  "Hebrews": Hebrews,
  "Hosea": Hosea,
  "Isaiah": Isaiah,
  "James": James,
  "Jeremiah": Jeremiah,
  "Job": Job,
  "Joel": Joel,
  "John": John,
  "Jonah": Jonah,
  "Joshua": Joshua,
  "Jude": Jude,
  "Judges": Judges,
  "Lamentations": Lamentations,
  "Leviticus": Leviticus,
  "Luke": Luke,
  "Malachi": Malachi,
  "Mark": Mark,
  "Matthew": Matthew,
  "Micah": Micah,
  "Nahum": Nahum,
  "Nehemiah": Nehemiah,
  "Numbers": Numbers,
  "Obadiah": Obadiah,
  "Philemon": Philemon,
  "Philippians": Philippians,
  "Proverbs": Proverbs,
  "Psalms": Psalms,
  "Revelation": Revelation,
  "Romans": Romans,
  "Ruth": Ruth,
  "Song of Solomon": Songs,
  "Titus": Titus,
  "Zechariah": Zechariah,
  "Zephaniah": Zephaniah,
}